import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "p-2 bg-light" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 col-12" }
const _hoisted_4 = { class: "col-md-3 col-12 fs-6 fw-bold" }
const _hoisted_5 = { class: "col-md-3 col-12 fs-6 fw-bold" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 col-12" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12 div-table-resumo" }
const _hoisted_10 = { class: "table table-sm table-bordered" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end fw-bold" }
const _hoisted_19 = { class: "text-end fw-bold" }
const _hoisted_20 = { class: "text-end fw-bold" }
const _hoisted_21 = { class: "text-end fw-bold" }
const _hoisted_22 = { class: "text-end fw-bold" }
const _hoisted_23 = { class: "text-end fw-bold" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "row mb-2" }
const _hoisted_29 = { class: "col-md-4 col-12" }
const _hoisted_30 = { class: "col-md-2 col-12" }
const _hoisted_31 = { class: "col-md-2 col-12" }
const _hoisted_32 = { class: "col-md-4 col-12" }
const _hoisted_33 = { class: "row pe-2" }
const _hoisted_34 = { class: "col-md-12 div-table-boletos pe-2" }
const _hoisted_35 = {
  class: "table table-striped table-hover table-sm table-bordered",
  style: {"min-width":"1800px"}
}
const _hoisted_36 = { class: "th-fixed" }
const _hoisted_37 = { class: "col-md-12 text-center table-danger" }
const _hoisted_38 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_39 = { class: "d-inline" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "text-start",
  "data-label": "Nro Docto"
}
const _hoisted_42 = {
  class: "text-start",
  "data-label": "Nosso Numero"
}
const _hoisted_43 = {
  key: 0,
  class: "text-start",
  "data-label": "Nosso Numero"
}
const _hoisted_44 = {
  class: "text-end",
  "data-label": "Cliente"
}
const _hoisted_45 = {
  class: "text-start",
  "data-label": "Nome Cliente"
}
const _hoisted_46 = {
  class: "text-center",
  "data-label": "Dt Vencimento"
}
const _hoisted_47 = {
  class: "text-end",
  "data-label": "Recebido R$"
}
const _hoisted_48 = {
  class: "text-end",
  "data-label": "Juros R$"
}
const _hoisted_49 = {
  class: "text-end",
  "data-label": "Out Créd R$"
}
const _hoisted_50 = {
  class: "text-end",
  "data-label": "Desctos R$"
}
const _hoisted_51 = {
  class: "text-end",
  "data-label": "Documento R$"
}
const _hoisted_52 = {
  class: "",
  "data-label": "Detalhes"
}
const _hoisted_53 = {
  class: "",
  "data-label": "status Processamento"
}
const _hoisted_54 = {
  class: "text-center",
  "data-label": "Opções"
}
const _hoisted_55 = { class: "opcoes" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark border-top" }
const _hoisted_58 = { class: "container-fluid" }
const _hoisted_59 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_60 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_61 = { class: "nav-item me-2" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "d-flex" }
const _hoisted_64 = { class: "navbar-nav" }
const _hoisted_65 = { class: "nav-item" }

import { onMounted, reactive,} from "vue";
import { useRouter, useRoute } from 'vue-router';

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,  fdataHora,  } from "@/utils/funcoes";

//componentes
import Pesquisa from "./Pesquisa.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import Loading from "@/components/Loading/index.vue"
import Paginador from "@/components/Paginador/Index.vue"
import Pergunta from "@/components/Pergunta/Index.vue"
import RetornoItensTarifas from "./RetornoItensTarifas.vue"
import RetornoItensStatusProcess from "./RetornoItensStatusProcess.vue"

//janelas

type configColuna = {
    coluna: string;
    exibe: boolean;
};



export default /*@__PURE__*/_defineComponent({
  __name: 'RetornoItens',
  setup(__props) {


//vue
const router = useRouter();
const route = useRoute();

var controle = reactive({
    filtros: {
        retornoId: 0 ,
        paginaAtual: 1,
        tamanhoPagina: 30,
        statusProcessamento: "",
    } as service.ObterRetornoItensFiltros,

    retorno: {} as service.BoletoRetorno,
    itens: [] as service.BoletoRetornoItemDTO[],
    tarifas: [] as service.BoletoRetornoItemDTO[],

    id: 0 as number,
    item: {} as service.BoletoRetornoItemDTO,

    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    
    listaResumo: [] as service.RetornoPorOcorrenciaDto[],
    listaPorStatus: [] as service.RetornoPorStatusDto[],


    resumo: {} as service.RetornoPorOcorrenciaDto,

    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    totais: {
        qtde: 0,
        total: 0,
    },
    colunas: [
        { coluna: "Id", exibe: true },
        { coluna: "Banco", exibe: true },
        { coluna: "Nosso Número", exibe: true },
        { coluna: "Docto Origem", exibe: true },
        { coluna: "Dt. Emissão", exibe: true },
        { coluna: "Dt. Vencto", exibe: true },
        { coluna: "Cliente", exibe: true },
        { coluna: "Razão social", exibe: true },
        { coluna: "Valor R$", exibe: true },
        { coluna: "Tipo Ocorrência", exibe: true },
        { coluna: "Usuário", exibe: true },
        { coluna: "Sequencial", exibe: true },
        { coluna: "Status", exibe: true },
    ] as configColuna[],

    janColunas: false,
    janDetalhes: false,


    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

    // Estados do diálogo de confirmação
    showConfirmDialog: false,
    processandoRetorno: false,

});



onMounted(() => {
    controle.filtros.retornoId = parseInt(route.params.id.toString());
    buscarResumo();
    pesquisar();
    buscarTarifas();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.itens = [] as service.BoletoRetornoItemDTO[];
    console.log("pesquisar");

    service.obterRetornoDetalhes(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.itens = r.dados
            controle.totalRegistros = r.totalRegistros;

            controle.totais.total = 0;

            controle.itens.forEach((boleto) => {
                controle.totais.qtde++;
                controle.totais.total += (boleto.valorDocumento ?? 0);
            });
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

const buscarTarifas = async () => {

    controle.tarifas = [] as service.BoletoRetornoItemDTO[];

    service.obterRetornoDetalhes({ocorrenciaIds: ["161"], retornoId: controle.filtros.retornoId, paginaAtual: 1, tamanhoPagina: 1000})
        .then((r) => {
            controle.tarifas = r.dados
        })
        .catch((erro: string) => {
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function buscarResumo() {

    controle.listaResumo = [] as service.RetornoPorOcorrenciaDto[];

    service.obterRetornoResumo(controle.filtros.retornoId as number)
    .then((r) => {
        controle.retorno = r.retorno;
        controle.listaResumo = r.resumoPorOcorrencia;
        controle.listaPorStatus = r.resumoPorStatus;
    })
    .catch((erro: string) => {
        console.error("Erro ao obter resumo do retorno:", erro);
    });

}

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.itens = controle.itens.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.itens = controle.itens.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

function exibirDetalhes(boleto: service.Boleto) {
    controle.boleto = boleto;
    controle.boletoId = boleto.boletoId ?? 0;
    controle.janDetalhes = true;
}

function selecionarResumo(resumo: service.RetornoPorOcorrenciaDto | null) {
    if (resumo == null) {
        controle.resumo = {} as service.RetornoPorOcorrenciaDto;
        controle.filtros.paginaAtual = 1;
        controle.filtros.tamanhoPagina = 30;
        controle.filtros.ocorrenciaIds = [];
        controle.filtros.statusProcessamento = "";
        pesquisar();
        return;
    }

    controle.filtros.paginaAtual = 1;
    controle.filtros.tamanhoPagina = resumo.qtde + 50;
    controle.filtros.ocorrenciaIds = [resumo.ocorrenciaId];
    controle.filtros.statusProcessamento = "";
    pesquisar();
    controle.resumo = resumo;
}

// Função para mostrar confirmação antes de processar retorno
function perguntaProcessar() {
    controle.showConfirmDialog = true;
}

// Função chamada quando o usuário responde ao diálogo
function confirmaProcessar(confirmou: boolean) {
    controle.showConfirmDialog = false;
    
    if (confirmou && controle.filtros.retornoId != null) {
        processarRetorno();
    }
    
}

// Função para processar o retorno
async function processarRetorno() {
    try {
        controle.loading = true;
        controle.processandoRetorno = true;
        controle.status = "Processando retorno...";
        
        // Aqui você chamaria o serviço para processar o retorno
        await service.processarRetorno(controle.filtros.retornoId as number);
        
        // Simular processamento por 2 segundos
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        controle.status = "Retorno processado com sucesso!";
        
        pesquisar();

        setTimeout(() => {
            controle.loading = false;
            controle.processandoRetorno = false;
        }, 3000);

        
    } catch (erro) {
        
        controle.erro = `Erro ao processar retorno: ${erro}`;

    } finally {
        
        controle.processandoRetorno = false;
        controle.loading = false;

        setTimeout(() => {
            controle.status = "";
        }, 3000);
    }
}



return (_ctx: any,_cache: any) => {
  const _component_NavBarStatus = _resolveComponent("NavBarStatus")!
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavBarStatus, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro = ''))
    }, null, 8, ["erro"]),
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createVNode(_component_Container, {
      width: 'full',
      class: _normalizeClass(['p-0  overflow-hidden h-100', "p-0"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_BreadCrumb, {
                "-page-title": 'Retornos',
                items: [
                            { label: 'Boletos', to: '/boletos' },
                            { label: 'Retornos', to: '/boletosRetornos' },
                            { label: `Retorno ${_unref(controle).filtros.retornoId}`, to: '#' },
                        ]
              }, null, 8, ["items"])
            ]),
            _createElementVNode("div", _hoisted_4, " Data: " + _toDisplayString(_unref(fdataHora)(_unref(controle).retorno.dataCadastro)), 1),
            _createElementVNode("div", _hoisted_5, " Cedente: " + _toDisplayString(_unref(controle).retorno.cedenteCodigo), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-12 col-12 fs-6 fw-bold" }, " Resumo por Ocorrência ", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Cód"),
                        _createElementVNode("th", null, "Ocorrência"),
                        _createElementVNode("th", { class: "text-end" }, "Qtde"),
                        _createElementVNode("th", { class: "text-end" }, "Recebido"),
                        _createElementVNode("th", { class: "text-end" }, "Juros"),
                        _createElementVNode("th", { class: "text-end" }, "Out Créd"),
                        _createElementVNode("th", { class: "text-end" }, "Desc"),
                        _createElementVNode("th", { class: "text-end" }, "Docto")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaResumo, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.ocorrenciaId,
                          onClick: ($event: any) => (selecionarResumo(item)),
                          style: {"cursor":"pointer"},
                          class: _normalizeClass(item.ocorrenciaId == _unref(controle).resumo.ocorrenciaId ? 'table-active' : '')
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.ocorrenciaId), 1),
                          _createElementVNode("td", null, _toDisplayString(item.descricao), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.qtde), 1),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(f2dec)(item.valorRecebido)), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(f2dec)(item.valorMoraJuros)), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(f2dec)(item.valorOutrosCreditos)), 1),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(f2dec)(item.valorDescontos)), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(f2dec)(item.valorDocumento)), 1)
                        ], 10, _hoisted_11))
                      }), 128)),
                      _createElementVNode("tr", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (selecionarResumo(null))),
                        style: {"cursor":"pointer"},
                        class: _normalizeClass(_unref(controle).resumo == null ? 'table-active' : '')
                      }, [
                        _cache[24] || (_cache[24] = _createElementVNode("td", null, null, -1)),
                        _cache[25] || (_cache[25] = _createElementVNode("td", null, "Totais", -1)),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(controle).listaResumo.reduce((acc, item) => acc + item.qtde, 0)), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(f2dec)(_unref(controle).listaResumo.reduce((acc, item) => acc + item.valorRecebido, 0))), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(f2dec)(_unref(controle).listaResumo.reduce((acc, item) => acc + item.valorMoraJuros, 0))), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(f2dec)(_unref(controle).listaResumo.reduce((acc, item) => acc + item.valorOutrosCreditos, 0))), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(f2dec)(_unref(controle).listaResumo.reduce((acc, item) => acc + item.valorDescontos, 0))), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(f2dec)(_unref(controle).listaResumo.reduce((acc, item) => acc + item.valorDocumento, 0))), 1)
                      ], 2)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(RetornoItensTarifas, {
                    itens: _unref(controle).tarifas
                  }, null, 8, ["itens"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_unref(controle).filtros.ocorrenciaIds)
                    ? (_openBlock(), _createBlock(RetornoItensStatusProcess, {
                        key: 0,
                        itens: _unref(controle).listaPorStatus,
                        "ocorrencia-id": _unref(controle).filtros?.ocorrenciaIds[0],
                        onFiltrar: _cache[2] || (_cache[2] = (a)=> {console.log('filtro',a.statusProcessamento); _unref(controle).filtros.statusProcessamento = a.statusProcessamento; pesquisar(); })
                      }, null, 8, ["itens", "ocorrencia-id"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _cache[28] || (_cache[28] = _createElementVNode("label", null, "Nome", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
                class: "form-control form-control-sm",
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (pesquisar()))
              }, null, 544), [
                [_vModelText, _unref(controle).filtros.nome]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[29] || (_cache[29] = _createElementVNode("label", null, "Nosso número", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).filtros.nossoNumero) = $event)),
                type: "text",
                class: "form-control form-control-sm",
                onKeyup: _cache[6] || (_cache[6] = ($event: any) => (pesquisar()))
              }, null, 544), [
                [_vModelText, _unref(controle).filtros.nossoNumero]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("a", {
                class: "btn btn-primary btn-sm mt-3",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (pesquisar()))
              }, [...(_cache[30] || (_cache[30] = [
                _createElementVNode("i", { class: "fa fa-search" }, null, -1),
                _createTextVNode(" Pesquisar ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_RouterLink, {
                to: '/boletosRetornosDiferencas/' + _unref(controle).filtros.retornoId,
                class: "btn btn-primary btn-sm mt-3 float-end"
              }, {
                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "fa fa-search" }, null, -1),
                  _createTextVNode(" Diferenças ", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("table", _hoisted_35, [
                _createElementVNode("thead", _hoisted_36, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "text-start",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('numeroDocumento')))
                    }, " Nro Docto "),
                    _createElementVNode("th", {
                      class: "text-start",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('nossoNumero')))
                    }, " Nosso Número "),
                    (_unref(controle).filtros.ocorrenciaId == null)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          class: "text-start",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('Pedido')))
                        }, " Ocorrência "))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (ordenarPor('clienteId')))
                    }, "Cliente"),
                    _createElementVNode("th", {
                      class: "text-start",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (ordenarPor('clienteNome')))
                    }, "Razão social"),
                    _createElementVNode("th", {
                      class: "text-center",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (ordenarPor('dataVencimento')))
                    }, "Dt. Vencto"),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Recebido R$"),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Juros R$"),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Out Créd R$"),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Desctos R$"),
                    _createElementVNode("th", {
                      class: "text-end",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (ordenarPor('nomeCidade')))
                    }, "Docto R$"),
                    _createElementVNode("th", {
                      class: "text-start",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Detalhes"),
                    _createElementVNode("th", {
                      class: "text-start",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (ordenarPor('vendedorNome')))
                    }, "Status Processamento"),
                    _cache[32] || (_cache[32] = _createElementVNode("th", { class: "text-center" }, "Opções", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _withDirectives(_createElementVNode("tr", null, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("td", {
                      colspan: "15",
                      class: "text-center"
                    }, [
                      _createElementVNode("div", { class: "d-inline" }, [
                        _createElementVNode("i", { class: "fa fa-cog fa-spin" }),
                        _createTextVNode(" Pesquisando... ")
                      ])
                    ], -1)
                  ]))], 512), [
                    [_vShow, _unref(controle).pesquisando == true]
                  ]),
                  _withDirectives(_createElementVNode("tr", _hoisted_37, [
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                      ]),
                      _createElementVNode("a", {
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (pesquisar()))
                      }, "Repetir")
                    ])
                  ], 512), [
                    [_vShow, _unref(controle).erro != '']
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: idx,
                      class: _normalizeClass(_unref(controle).id == item.id ? 'table-active' : (item.clienteId == 0 ? 'table-danger' : '')),
                      onClick: ($event: any) => {_unref(controle).id = item.id; _unref(controle).item = item}
                    }, [
                      _createElementVNode("td", _hoisted_41, _toDisplayString(item.numeroDocumento), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(item.nossoNumero), 1),
                      (_unref(controle).filtros.ocorrenciaId == null)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(item.ocorrenciaDescricao), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(item.clienteId), 1),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(item.clienteNome), 1),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(_unref(fdata)(item.dataVencimento)), 1),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(f2dec)(item.valorRecebido)), 1),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(_unref(f2dec)(item.valorMoraJuros)), 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(f2dec)(item.valorOutrosCreditos)), 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(f2dec)(item.valorDescontos)), 1),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(_unref(f2dec)(item.valorDocumento)), 1),
                      _createElementVNode("td", _hoisted_52, _toDisplayString(item.motivosRejeicao), 1),
                      _createElementVNode("td", _hoisted_53, _toDisplayString(item.statusProcessamento), 1),
                      _createElementVNode("td", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("a", {
                            class: "btn-link me-1",
                            href: "javascript:void(0)",
                            onClick: ($event: any) => (exibirDetalhes(item)),
                            title: "Exibir detalhes do boleto"
                          }, [...(_cache[35] || (_cache[35] = [
                            _createElementVNode("i", { class: "fa fa-search" }, null, -1)
                          ]))], 8, _hoisted_56)
                        ])
                      ])
                    ], 10, _hoisted_40))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("ul", _hoisted_60, [
            _createElementVNode("li", _hoisted_61, [
              (_unref(controle).resumo.status != 2)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "nav-link",
                    h: "",
                    href: "javascript:void(0)",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (perguntaProcessar(_ctx.item))),
                    disabled: _unref(controle).processandoRetorno,
                    title: "Processar retorno"
                  }, [...(_cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "fa fa-play" }, null, -1),
                    _createTextVNode(" Processar Retorno ", -1)
                  ]))], 8, _hoisted_62))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("ul", _hoisted_64, [
              _createElementVNode("li", _hoisted_65, [
                _createElementVNode("a", {
                  class: "nav-link",
                  href: "#",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_unref(router).back()))
                }, [...(_cache[37] || (_cache[37] = [
                  _createElementVNode("i", { class: "fa fa-close" }, null, -1),
                  _createTextVNode(" Fechar ", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Pergunta, {
      exibir: _unref(controle).showConfirmDialog,
      titulo: "Processar Retorno",
      mensagem: `Deseja processar o retorno ${_unref(controle).filtros.retornoId}?`,
      detalhes: `Esta ação irá atualizar os boletos conforme as informações do retorno. Deseja continuar?`,
      tipo: "warning",
      textoSim: "Processar",
      textoNao: "Cancelar",
      processando: _unref(controle).processandoRetorno,
      onResposta: confirmaProcessar
    }, null, 8, ["exibir", "mensagem", "processando"])
  ], 64))
}
}

})